import { Divider } from '@gravity-ui/uikit';

import { InfoCard } from 'features/ui-kit/info-card';
import { getGenderTypeText, getSpokesmanTypeText, yearToDisplayText } from 'features/utils';
import type { Blank } from 'store/types/common';

import {
	ADDITIONAL_INFORMATION,
	BIRTH_YEAR,
	CLIENT_INFO,
	CLIENT_REQUEST,
	DIAGNOSIS,
	GENDER,
	INSTITUTION,
	QUESTIONS,
	USER_AGREEMENT,
	VIOLATIONS,
} from '../constants';
import { ClientAgreement } from '../utils';

import styles from './styles.module.scss';

interface ClientInfoProps {
	data: Blank;
}

export const ClientInfo = ({ data }: ClientInfoProps) => {
	return (
		<div className={styles.info}>
			<h3 className={styles.info__title}>{CLIENT_INFO}</h3>

			<InfoCard
				className={styles.info__card}
				values={[
					[BIRTH_YEAR, yearToDisplayText(new Date(data.birthday))],
					[GENDER, getGenderTypeText(data.gender)],
					[INSTITUTION, data.establishment?.name ? data.establishment.name : undefined],
					[QUESTIONS, getSpokesmanTypeText(data.spokesman)],
					[VIOLATIONS, data.violations],
				]}
			/>

			<Divider />

			<InfoCard
				className={styles.info__card}
				values={[
					[DIAGNOSIS, data.diagnosis],
					[ADDITIONAL_INFORMATION, data.additionalInformation],
					[CLIENT_REQUEST, data.customerRequest],
				]}
			/>

			<Divider />

			<InfoCard
				values={[
					// eslint-disable-next-line react/jsx-key
					[USER_AGREEMENT, <ClientAgreement value={data.consent} />], // Пользовательское соглашение
				]}
			/>
		</div>
	);
};
